<form clrForm [formGroup]="personForm">
  <clr-input-container>
    <label>Anrede</label>
    <input clrInput type="text" formControlName="salutation">
  </clr-input-container>

  <clr-input-container>
    <label>Vorname</label>
    <input clrInput formControlName="firstname" placeholder="Vorname">
    <clr-control-error *ngIf="personForm.get('firstname')?.invalid">Pflichtfeld</clr-control-error>
  </clr-input-container>

  <clr-input-container>
    <label>Nachname</label>
    <input clrInput formControlName="lastname" placeholder="Nachname">
    <clr-control-error *ngIf="personForm.get('lastname')?.invalid">Pflichtfeld</clr-control-error>
  </clr-input-container>

  <clr-input-container>
    <label>Position</label>
    <input clrInput type="text" formControlName="position" />
  </clr-input-container>

  <clr-input-container *ngIf="crmMode">
    <label>CRM-ID</label>
    <input clrInput type="text" formControlName="crm_id" />
  </clr-input-container>

  <clr-input-container>
    <label>Telefon</label>
    <input clrInput type="text" formControlName="phone" />
  </clr-input-container>

  <clr-input-container>
    <label>Mobil</label>
    <input clrInput type="text" formControlName="mobile" />
  </clr-input-container>

  <clr-input-container>
    <label>E-Mail 1</label>
    <input clrInput formControlName="email" type="email" placeholder="E-Mail">
    <clr-control-error *ngIf="personForm.get('email')?.invalid">Ungültige E-Mail-Adresse</clr-control-error>
  </clr-input-container>

  <clr-input-container>
    <label>E-Mail 2</label>
    <input clrInput type="text" formControlName="email2" />
  </clr-input-container>

  <clr-input-container>
    <label>E-Mail 3</label>
    <input clrInput type="text" formControlName="email3" />
  </clr-input-container>

  <clr-input-container>
    <label>Straße</label>
    <input clrInput type="text" formControlName="street" />
  </clr-input-container>

  <clr-input-container>
    <label>PLZ</label>
    <input clrInput type="text" formControlName="postcode" />
  </clr-input-container>

  <clr-input-container>
    <label>Ort</label>
    <input clrInput type="text" formControlName="city" />
  </clr-input-container>

  <clr-select-container>
    <label>Bundesland</label>
    <select clrSelect formControlName="region" >
      <option value=""></option>
      <option value="Baden-Württemberg">Baden-Württemberg</option>
      <option value="Bayern">Bayern</option>
      <option value="Berlin">Berlin</option>
      <option value="Brandenburg">Brandenburg</option>
      <option value="Bremen">Bremen</option>
      <option value="Hamburg">Hamburg</option>
      <option value="Hessen">Hessen</option>
      <option value="Mecklenburg-Vorpommern">Mecklenburg-Vorpommern</option>
      <option value="Nordrhein-Westfalen">Nordrhein-Westfalen</option>
      <option value="Rheinland-Pfalz">Rheinland-Pfalz</option>
      <option value="Sachsen">Sachsen</option>
      <option value="Saarland">Saarland</option>
      <option value="Sachsen">Sachsen</option>
      <option value="Sachsen-Anhalt" selected>Sachsen-Anhalt</option>
      <option value="Schleswig-Holstein">Schleswig-Holstein</option>
      <option value="Thüringen">Thüringen</option>
    </select>
  </clr-select-container>
  <app-country-select controlName="country" label="Land" />
  <clr-select-container>
    <label>Status</label>
    <select clrSelect formControlName="active" >
      <option value="true">aktiv</option>
      <option value="false">passiv</option>
    </select>
  </clr-select-container>
</form>
